<template>
  <div>
    <section class="uk-margin">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link to="/admin">Администрирование</router-link>
          </li>
          <li class="is-active">
            <a href="#">Полномочия</a>
          </li>
        </ul>
      </nav>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
    <section class="uk-margin">
      <b-field grouped group-multiline>
        <b-field label="Сортировка">
          <b-select v-model="filters.order" @input="pageChange()">
            <option value="asc">Восходящая (ASC)</option>
            <option value="desc">Нисходящая (DESC)</option>
          </b-select>
        </b-field>
        <b-field label="На страницу">
          <b-select v-model="filters.limit" @input="pageChange()">
            <option
              v-for="option in limits"
              :value="option"
              :key="option">
              {{ option }} шт.
            </option>
          </b-select>
        </b-field>
      </b-field>
    </section>
    <section class="uk-margin">
      <b-table
        :bordered="true"
        :hoverable="true"
        :data="data"
        :default-sort-direction="filters.order">
        <template slot-scope="props" @click="click">
          <b-table-column field="id" label="ID" width="40" sortable numeric>
            {{ props.row.id }}
          </b-table-column>
          
          <!-- <b-table-column field="date" label="Дата создания" sortable>
            {{ props.row.date }}
            {{ moment(props.row.date).add(moment().utcOffset(), 'minute').format('YYYY-MM-DD HH:ss:mm') }}
          </b-table-column> -->

          <b-table-column field="value" label="Значение" sortable>
            {{ props.row.value }}
          </b-table-column>

          <b-table-column field="description" label="Описание" sortable>
            {{ props.row.description }}
          </b-table-column>

          <b-table-column field="roles" label="Роли" sortable>
            {{ props.row.roles }}
          </b-table-column>
          
          <b-table-column label="Действие" centered>
            <div class="block">
              <a href="#" @click="editRow(props.row.id)" style="margin-right: .35rem;">
                <b-icon icon="pen" type="is-dark" size="is-small"></b-icon>
              </a>
            </div>
          </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                icon="sad-tear"
                size="is-large">
              </b-icon>
            </p>
            <p>Данных нет.</p>
          </div>
        </section>
      </template>
      </b-table>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>    
  </div>
</template>

<script>

import { EventBus } from '@/utils'
export default {
  name: "PermissionTable",
  data() {
    const limits = [
      5, 10, 20, 25, 50, 75, 100
    ]
    const data = []
    return {
      data: data,
      limits: limits,
      currentPage: 1,
      total: 0,
      filters: {
        is_active: null,
        order: 'asc',
        limit: 25
      }
    }
  },
  mounted: function() {
    this.$store.dispatch('getPermissions')
      .then(response => {
        let data = response.data;
        this.total = data.total
        data.data.forEach((item) => {
          this.data.push(item)
        })
      })
      .catch(error => {
        this.data = []
      })
    
    EventBus.$on('successUpdatePermission', () => {
      this.pageChange()
    })

  },
  beforeDestroy: function(){
    EventBus.$off('successUpdatePermission')
  },
  methods: {
    editRow(item){
      EventBus.$emit("showModal", "permission.edit", item)
    },
    clearState(){
      this.filters.is_active = null
      this.pageChange()
    },
    pageChange(page){
      if(page){
        this.currentPage = page
      }
      this.$store.dispatch('getPagePermissions', { page: this.currentPage, filters: this.filters })
        .then(response => {
          let data = response.data;
          this.data = []
          this.total = data.total
          data.data.forEach((item) => {
            this.data.push(item)
          })
        })
        .catch(error => {
          this.data = []
        })
    }
  }
}
</script>